module.exports = __webpack_public_path__ + "img/icon-search.65957908.png";